import * as $ from 'jquery';
import 'bootstrap';
import * as Slideout from 'slideout';
var headroom = require('headroom');
import { bookingFormCommon } from "./c005-bookingform-common";
import { loginForm } from "./c005-login";
import 'MagnificPopup';
export class headerContent {
	$scope: any = $('#mab-header');
	$navbarToggle: any = $('.navbar-toggle');
	$mabNavOverlay: any = $('.mab-nav--overlay');
	$bookingNav: any = $('#mab-bookingnav.desktop');
	$bookingNavMobile: any = $('#mab-bookingnav.mobile');
	$enrich:any = $('.enrich-login, .enrich-login--overlay');
	$alertContainer:any = $('#alert-container');
	$mabHeader: any = $('#mab-header');
	$bannerHeight: any = $('.banner-container');
	$stickyNavHeight:any;
	$stickyNavHeightMob: any;
	$ibeFormContainer: any = $('.ibe-form--container');
	$ibeNavList: any = $('#bookingNav li');
	$scroll: any = $(window).scrollTop();
	$mainContent: any = $('#main-content');
	private bookingformcommon = new bookingFormCommon();

	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}

	isUserLoggedIn():boolean {
		let _self = this;
		let parts1 =_self.getCookie("phantom");
		let cookieAccessToken = _self.getCookie("sapphire");
		if (cookieAccessToken && cookieAccessToken!=="undefined")
		{			
			if(parts1) {
				let userName = JSON.parse(parts1).firstName;
				$(".username").html(userName);
				let splitUserName = userName.split(" ");
				let firstNameChar = splitUserName[0].charAt(0);
				let lastNameChar = "";
				$(".enrich-login--success").attr("data-enrich-firstname",firstNameChar);
				$(".enrich-login--success").attr("data-enrich-lastname",lastNameChar);
				if (window.location.href.indexOf('enrich-portal') > 0) {
					$(".enrich-login--success").addClass("enrich-menu-hide");
					$("#slide-nav .navbar-toggle").addClass("enrich-menu-hide");
				} 
				else {
					$(".enrich-login--success").removeClass("enrich-menu-hide");
					$("#slide-nav .navbar-toggle").removeClass("enrich-menu-hide");
				}
				_self.enrichMember();
				return true;
			}
		}
		
		return false;
	}
	
	getParameterByName():any {

		let _self = this;
		let defer = $.Deferred();	
		let loggedIn = _self.isUserLoggedIn();
		if (!loggedIn) {
			let cookieAccessToken = _self.getCookie("sapphire");
			if (cookieAccessToken && cookieAccessToken!=="undefined")
			{
				_self.bookingformcommon.preloader();				
				var decodedToken = parseJwt(cookieAccessToken);
				console.log(decodedToken);
	
				desktopValidation(decodedToken,cookieAccessToken).done((res:any) => {
					if(res=="OK")
					{
						defer.resolve("OK");					
					}
					else
					{
						defer.reject(res);					
					}
				});
				
			}
			else{
				defer.resolve("OK");	
				_self.bookingformcommon.preloaderClose();
			}
	
		}
		else{
			defer.resolve("OK");
		}		
		
		return defer.promise();
		
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};

		function desktopValidation(decodedToken:any,accessToken:any){
			
			let defer = $.Deferred();
			console.log('Success');
			 	var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid
				};
			
					$.ajax({
							type: 'POST',
							url:'/bin/services/new/azureauthuser',
							data: data,
							success: function(msg:string) {
							//_self.redirectUser(msg);
							//_self.$loginErrorValidation.show();
							var json = JSON.parse(msg);
							var responseCode = json.responseCode;
							if (responseCode == "OK") {
								console.log("success");
								//var loginSuccess = $("#exceptionmsg").attr("data-loginsuccess");
			
								var d = new Date();
								d.setTime(d.getTime() + (30 * 60 * 1000));
								var expires = "expires="+d.toUTCString();
								
								//document.cookie="accessToken="+accessToken+";"+expires+";path=/";
							//	document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
								document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
								document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
								document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
								document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
								document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/";
								 _self.bookingformcommon.preloaderClose();
								//window.location.href = loginSuccess;
								window.location.reload();
								defer.resolve("OK");
			
							  // Redirect to the configured page from here.
						  } 
						  
						},
						error: function(error:any) {
							console.log('Fail submit');
							_self.bookingformcommon.preloaderClose();
							// _self.$ibeFormContainer.hide();
							defer.reject(error);
						}
					  });	
					  
					  return defer.promise();
				}

	}
	// Initialize mobile slider navigation
	slideNav(): void {

		let _self = this;

		var slideout:any = new Slideout({
			'panel': document.getElementById('main-content'),
			'menu': $('.mab-nav--overlay')[0],
			'padding': $('.enrich-revamp').length > 0? (window.innerWidth > 767)? 375: window.innerWidth: 310,
			'tolerance': 70,
			'side': 'right',
			'easing': 'cubic-bezier(.32,2,.55,.27)'
		});

		_self.$scope.find('.navbar-toggle').on('click', () =>{
				slideout.toggle();
		});
		if ($('.enrich-revamp').length > 0) {
			$('.enrich-revamp .slideOutClose').on('click', () => {
				slideout.close();
			});
		}

		let top:number = 0;
		let $body:any = $('body');

		slideout.on('open', () => {
	/*	top = $(window).scrollTop();
			$body.css({
				'position': 'fixed',
				'top': -top
			});*/
			// $body.css('no-scroll');
			// $('#overlay-container').toggleClass('no-scroll');
		});

		slideout.on('close', () => {
			// $body.css({
			// 	'position': '',
			// 	'top': ''
			// });
			//$body.scrollTop(top);
			// $body.toggleClass('no-scroll');
			// $('#overlay-container').toggleClass('no-scroll');
		});

		// close slideout menu when booking nav ibe links are clicked
		// shift page scroll position to ibe action height when ibe links are clicked
		// (as the links trigger js anchors within the same page)

		let $bookingNavLinks:any  = _self.$mabNavOverlay.find('li.booking-nav');
		let $bookingIbeHeight:any = _self.$bookingNavMobile.find('#bookingNav').offset();
		let $loginClassName:string = 'mobile-enrich-login';

		for (var i=0, len=$bookingNavLinks.length; i<len; i++) {
			let $currClassName:string = $bookingNavLinks[i].childNodes[0].className;
			// console.log($currClassName); // get childnode <a> classname
			$($bookingNavLinks[i]).on('click', function(e:any){
				slideout.close();

				// scroll window to set ibe as top of page, except for login link.
				// login link opens a new modal so set window to scroll to page top
				if ($currClassName !== $loginClassName) {
					$(window).scrollTop($bookingIbeHeight.top);
				} else {
					$(window).scrollTop(0);
				}
			});
		}

		/**
		 * MABUAT1-5
		 * - add event handler to mainContent for toggling slideout when
		 *   open.
		 */
		// when slideout is open, on click main content area, close menu
		slideout
		.on('open', function(){
				_self.$mainContent.addClass('slideout-open');
				_self.$mainContent.on('click', function(e:any){
					// e.preventDefault();
					// e.stopPropagation();
					slideout.close();
				});
			})
		.on('close', function(){
			_self.$mainContent.removeClass('slideout-open');
			_self.$mainContent.unbind('click');
		});
	}
	/** MABUAT1-5 **/

	// Initialize sticky navigation for header
	stickyNav(): void {
		let _self = this;
		let $windowWidth:number = $(window).width();
		let $bannerHeight:number = 0;

		// double check in case multiple banners are loaded on page
		_self.$bannerHeight.each(function(i:number, el:any){
			 $bannerHeight += $(el).height();
		});

		if (_self.$alertContainer.is(':visible')) {
			_self.$stickyNavHeight = _self.$alertContainer.height() + _self.$mabHeader.height();
			_self.$stickyNavHeightMob = _self.$alertContainer.height() + _self.$mabHeader.height() + ($bannerHeight/2);
		} else {
			_self.$stickyNavHeight = _self.$mabHeader.height();
			_self.$stickyNavHeightMob = _self.$mabHeader.height() + $bannerHeight;
		}

		// initialize headroom
		let $mabbnavMobile:any = $('#mab-bookingnav.mobile');
		let $mabbnavDesktop:any = $('#mab-bookingnav.desktop');
		let $mabmainnav:any = $('#mab-header.mobile');

		if ($mabmainnav.parent().parent().hasClass('container')) {
			$mabmainnav.parent().parent().addClass('container--main-header');
      _self.calcMainnavOffset();
		}
	}

	enrichMember(): void {
		let $enrichLoginSuccess: any = $('.enrich-login--success');
		if ($enrichLoginSuccess.length > 0){
			let $enrichMemFirstName: any = $('.enrich-login--success').attr('data-enrich-firstname');
			let $enrichMemLastName: any  = $('.enrich-login--success').attr('data-enrich-lastname');
			let $enrichMemFirstNameChar: any = $enrichMemFirstName.charAt(0);
			let $enrichMemLastNameChar: any = "";
			let $enrichMemSuccess: any = $('.enrich-login--success .member');
			let $enrichSuccessVal: any = $enrichMemFirstNameChar + '' + $enrichMemLastNameChar;
			$enrichMemSuccess.html($enrichSuccessVal);
			if (window.location.href.indexOf('enrich-portal') > 0) {
				$(".enrich-login--success").addClass("enrich-menu-hide");
				$("#slide-nav .navbar-toggle").addClass("enrich-menu-hide");
			} 
			else {
				$(".enrich-login--success").removeClass("enrich-menu-hide");
				$("#slide-nav .navbar-toggle").removeClass("enrich-menu-hide");
			}
		}
	}

	secondaryBtn(): void {
		$('.btn-secondary').hover(function () {
			$(this).toggleClass('addBlueBkg');
		});
	}

	hardReload(): void {
		$(window).on('pageshow', function () {
			var preStatus = $('#status');
			var preEl = $('#preloader');
			if (preStatus.is(':visible') || preEl.is(':visible')) {
				console.log('preloader visible on load');
				preStatus.fadeOut(250);
				preEl.fadeOut(250);
			}
		});

		if (!!window.performance && window.performance.navigation.type === 2) {
			var pageUrl = location.href;
			location.href = pageUrl;
		}

	}

	/**
	 * Hotfix to resolve android focus issue on mobile sidebar input
	 * https://stackoverflow.com/questions/23757345/android-does-not-correctly-scroll-on-input-focus-if-not-body-element
	 * @return {any} [description]
	 */
	androidInputHotfix(): void {
		if(/Android/.test(navigator.appVersion)){
			window.addEventListener("resize", function(){
				if(document.activeElement.tagName=="INPUT"){
					window.setTimeout(function(){
						let activeElement: any = document.activeElement;
						activeElement.scrollIntoViewIfNeeded();
					},0);
				}
			})
		}
	}

	preloader(): void {
		$(window).load(function() {
			$('#status').fadeOut();
			$('#preloader').delay(1000).fadeOut('slow');
		})
	}

	/**
	 * [calcMainnavOffset description]
	 * re-calculate main nav offset when any of these components are changed or clicked
	 * - alert component
	 * - pdpa component
	 *
	 * function is not run by default and must be called manually
	 */
	calcMainnavOffset(): void {
		let alertEl = $('.alert-container');
		let pdpaEl = $('.cc-window').first();
		let alertHeight = alertEl.is(':visible') ? alertEl.outerHeight() : 0;
		let pdpaHeight = pdpaEl.is(':visible') ? pdpaEl.outerHeight() : 0;
		let offset = alertHeight + pdpaHeight + 1;

		let header = $('#mab-header');

		// destroy headroom and re-init with new offset
		// creates a minor flash but unavoidable.
		// console.log('headroom recalc', offset);
		header.headroom('destroy').headroom({offset: offset});
	}

	grayscaleColor(): void {
		let $thURLPath:any = window.location.href.split('/')[3];
		if($thURLPath === 'th'){
			$('html').addClass('grayscale');
		} else{
			$('html').removeClass('grayscale');
		}
	}

	/**
	 * replace all `/master/` path in ALL anchor links with
	 * country name if found
	 */
	linkRemapping(): void {
		$('a').each(function() {
			let $this = $(this);
			let path = location.pathname;
			let pathSegments = path.split("/");
			let href = $this.attr('href');

			if (href && href.indexOf("/master/") > -1) {
				var country = pathSegments[1];
				if (country == 'content') {
					country = pathSegments[3];
				}
				$this.attr({
					'href': href.replace('/master/','/'+country+'/')
				});
			}

			// add rel='noopener' for target='_blank' elements
			if ($this.attr('target') === '_blank') {
				$this.attr({
					'rel': 'noopener'
				});
			}
		});
	}

	checkIEVersion(): void{
		var version = this.detectIE();
		if(version!=false){
		if(version <= 10){
			$(".ieVersion-checker-popup").removeClass('hide');
			$(".ieLessThanEleven").hide();
	
		}
		else if(version == 11 ){
			
			$(".ieVersion-checker-popup").removeClass('hide');
			$(".ieLessThanTen").hide();

		}			
		}
	}
	detectIE() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		var edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		return false;
	}
	checkIEVersion_disablePupup(): void{
		var version = this.detectIE();
		if(version!=false){
			if(version <= 10){
				$("#ieVersion-checker-popup-blocker").removeClass('hide');
				$(".ieLessThanElevenBlocker").hide();
				$.magnificPopup.open({
					items: {
						src: '#ieVersion-checker-popup-blocker'
					},
					type: 'inline',
					midClick: true,
					enableEscapeKey: false,
					showCloseBtn: true,
					closeOnBgClick: false,
					callbacks: {
						open: function () {
							$(".ieLessThanElevenBlocker").hide();
						},
						close: function () {
						}
					}
				}, 0);
				throw new Error("Flight search will not support in IE version 10 or lesser!");
			}
		
			}
	}
	disableIEVersion_disablePupup(): void{
		var version = this.detectIE();
		if(version!=false){
				$("#disableieVersion-checker-popup-blocker").removeClass('hide');
				$.magnificPopup.open({
					items: {
						src: '#disableieVersion-checker-popup-blocker'
					},
					type: 'inline',
					midClick: false,
					enableEscapeKey: false,
					showCloseBtn: false,
					closeOnBgClick: false,
					closeOnContentClick:false
				}, 0);
				throw new Error("Flight search will not support in IE version 10 or lesser!");
			
			}
	}
}

let scope:Element = document.querySelector('#mab-header');
if (scope){
		try {
		let headercontent = new headerContent();
		headercontent.disableIEVersion_disablePupup();
			// headercontent.countryselectorMobile();
			// headercontent.enrichMember();
			// headercontent.grayscaleColor();
		headercontent.getParameterByName().done((result: any) => {
		if(result === "OK")
		{
			headercontent.linkRemapping();
			headercontent.stickyNav();
			headercontent.secondaryBtn();
			headercontent.hardReload();
			headercontent.checkIEVersion();

			$(document).ready(function(){
				//if ($('main-content').length > 0) {
					headercontent.slideNav();
				//}
				if ((/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$('body').css("height", "100%");
					$('body').css("min-height", "0");
					$('.container--main-header').css("position", "sticky");
					$('.container--main-header').css("top", "0");
				}
			});
		}
	});
	} catch(e) {console.error(e);}
}
